import React from 'react';
import loadable from '@loadable/component';
import FullScreenLoader from './components/FullScreenLoader';

const Home = loadable(() => import('./pages/Home'), {
  fallback: <FullScreenLoader />,
});

const AppLanding = loadable(() => import('./pages/AppLanding'), {
  fallback: <FullScreenLoader />,
});

const QuoteApproval = loadable(() => import('./pages/FmQuoteApproval'), {
  fallback: <FullScreenLoader />,
});

const QuoteProposalOrder = loadable(
  () => import('./pages/FmQuoteProposalOrder'),
  {
    fallback: <FullScreenLoader />,
  }
);

const FmProofApproval = loadable(() => import('./pages/FmProofApproval'), {
  fallback: <FullScreenLoader />,
});

const FmDigitalContractApproval = loadable(
  () => import('./pages/FmDigitalContractApproval'),
  {
    fallback: <FullScreenLoader />,
  }
);

const CustomRedirect = loadable(() => import('./pages/CustomRedirect'), {
  fallback: <FullScreenLoader />,
});

const UserReviews = loadable(() => import('./pages/UserReviews'), {
  fallback: <FullScreenLoader />,
});

const UserEnquiries = loadable(() => import('./pages/UserEnquiries'), {
  fallback: <FullScreenLoader />,
});

const UserQuotes = loadable(() => import('./pages/UserQuotes'), {
  fallback: <FullScreenLoader />,
});

const UserSaved = loadable(() => import('./pages/UserSaved'), {
  fallback: <FullScreenLoader />,
});

const Listview = loadable(() => import('./pages/Listview'), {
  fallback: <FullScreenLoader />,
});

const NotFound = loadable(() => import('./pages/NotFound'), {
  fallback: <FullScreenLoader />,
});

const Profile = loadable(() => import('./pages/Profile'), {
  fallback: <FullScreenLoader />,
});
const Region = loadable(() => import('./pages/Region'), {
  fallback: <FullScreenLoader />,
});

const Suburb = loadable(() => import('./pages/Suburb'), {
  fallback: <FullScreenLoader />,
});

const State = loadable(() => import('./pages/State'), {
  fallback: <FullScreenLoader />,
});

const ManageListing = loadable(() => import('./pages/ManageListing'), {
  fallback: <FullScreenLoader />,
});

const Sitemap = loadable(() => import('./pages/Sitemap'), {
  fallback: <FullScreenLoader />,
});

const CategorySitemap = loadable(() => import('./pages/CategorySitemap'), {
  fallback: <FullScreenLoader />,
});

const Category = loadable(() => import('./pages/Category'), {
  fallback: <FullScreenLoader />,
});

const AppLoginError = loadable(() => import('./pages/AppLoginError'), {
  fallback: <FullScreenLoader />,
});

const LoginLoader = loadable(() => import('./pages/LoginLoader'), {
  fallback: <FullScreenLoader />,
});

const ListingPost = loadable(() => import('./pages/ListingPost'), {
  fallback: <FullScreenLoader />,
});

const Guides = loadable(() => import('./pages/Guides'), {
  fallback: <FullScreenLoader />,
});

const CategoryGuide = loadable(() => import('./pages/CategoryGuide'), {
  fallback: <FullScreenLoader />,
});

const Article = loadable(() => import('./pages/Article'), {
  fallback: <FullScreenLoader />,
});

const routes = [
  {
    path: '/',
    component: Home,
    exact: true,
    strict: true,
  },
  {
    path: '/guides',
    component: Guides,
    exact: true,
    strict: true,
  },
  {
    component: CategoryGuide,
    path: '/guides/:categoryName',
    exact: true,
    strict: true,
  },
  {
    path: '/guides/:categoryName/:articleTitle',
    component: Article,
    exact: true,
    strict: true,
  },
  {
    path: '/localsearch-app',
    component: AppLanding,
    exact: true,
    strict: true,
  },
  {
    path: '/quote-approval',
    component: QuoteApproval,
    exact: true,
    strict: true,
  },
  {
    path: '/quote-proposal-order',
    component: QuoteProposalOrder,
    exact: true,
    strict: true,
  },
  {
    path: '/fm-proof-approval',
    component: FmProofApproval,
    exact: true,
    strict: true,
  },
  {
    path: '/fm-digital-contract-approval',
    component: FmDigitalContractApproval,
    exact: true,
    strict: true,
  },
  {
    path: '/:home(regions|contact-us)',
    component: CustomRedirect,
    external: false,
    exact: true,
    strict: true,
    target: '/',
  },
  {
    component: CategorySitemap,
    path: '/find',
    exact: true,
    strict: true,
  },
  {
    component: Category,
    path: '/find/:categoryName',
    exact: true,
    strict: true,
  },
  {
    path: '/find/:categoryName/australia',
    component: CustomRedirect,
    external: false,
    exact: true,
    strict: true,
    target: '/',
  },
  {
    path: '/recommended',
    component: CustomRedirect,
    external: false,
    target: '/sitemap',
  },
  {
    path: '/find//',
    component: CustomRedirect,
    external: false,
    target: '/sitemap',
  },
  {
    path:
      '/find/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20})',
    component: CustomRedirect,
    external: false,
    exact: true,
    strict: true,
    target: '/',
  },
  {
    path: '/:b2b(portfolio|web-services|advertise-with-us|sponsorship)',
    component: CustomRedirect,
    external: true,
    target: 'https://business.localsearch.com.au/',
    exact: true,
    strict: true,
  },
  {
    path: '/:b2babout(about-us|mobile)',
    component: CustomRedirect,
    external: true,
    target: 'https://business.localsearch.com.au/about-us/',
  },
  {
    path: '/legal',
    component: CustomRedirect,
    external: true,
    exact: true,
    strict: true,
    target: 'https://business.localsearch.com.au/legal/',
  },
  {
    path: '/review-guidelines',
    component: CustomRedirect,
    external: true,
    exact: true,
    strict: true,
    target: 'https://business.localsearch.com.au/content-integrity/',
  },
  {
    path: '/faq',
    component: CustomRedirect,
    external: true,
    exact: true,
    strict: true,
    target: 'https://business.localsearch.com.au/faq/',
  },
  {
    path: '/websites',
    component: CustomRedirect,
    external: true,
    exact: true,
    strict: true,
    target: 'https://business.localsearch.com.au/website-design-development/',
  },
  {
    path: '/suburbs/:legacySuburb',
    component: CustomRedirect,
    external: false,
    exact: true,
    strict: true,
    target: '/',
  },
  {
    path: '/profile/ryan-casey-constructions/QVsA',
    component: CustomRedirect,
    external: false,
    exact: true,
    strict: true,
    target: '/profile/ryan-casey-constructions/mareeba-qld/QVsA',
  },
  {
    path: '/profile/ettalong-50-leisure-learning-centre/ettalong-beach',
    component: CustomRedirect,
    external: false,
    exact: true,
    strict: true,
    target: '/find/fitness-centres-gyms/ettalong-beach-nsw',
  },
  {
    path: '/El-Arish,QLD/El-Arish-History-Station-Museum/profile/gF3K',
    component: CustomRedirect,
    external: false,
    exact: true,
    strict: true,
    target: '/profile/el-arish-history-station/el-arish-qld/gF3K',
  },
  {
    component: AppLoginError,
    path: '/app-login-error',
    exact: true,
    strict: true,
  },
  {
    component: Sitemap,
    path: '/sitemap/:letter?',
    exact: true,
    strict: true,
  },
  {
    component: Listview,
    path:
      '/find/:categoryName/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20})',
    exact: true,
    strict: true,
  },

  {
    component: Listview,
    path:
      '/find/:categoryName/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20}-[0-9]{4})',
    exact: true,
    strict: true,
  },
  {
    component: Listview,
    path:
      '/find/:categoryName/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20})/:pagination',
    exact: true,
    strict: true,
  },
  {
    component: Listview,
    path:
      '/find/:categoryName/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20}-[0-9]{4})/:pagination',
    exact: true,
    strict: true,
  },
  {
    component: Listview,
    path: '/search',
    exact: true,
  },
  {
    component: Listview,
    path:
      '/find/:categoryName/:state(qld|nsw|nt|tas|vic|sa|wa|act)/:region/:suburb?',
    exact: true,
    strict: true,
  },
  {
    component: Listview,
    path:
      '/:legacySuburbRoute([a-z][-a-z0-9\\._]{1,20},[qld|nsw|nt|tas|vic|sa|wa|act]{0,20})/:categoryName/:list?',
    exact: true,
  },
  {
    component: UserReviews,
    path: '/reviews',
    exact: true,
    strict: true,
  },
  {
    component: UserQuotes,
    path: '/quotes',
    exact: true,
    strict: true,
  },
  {
    component: UserEnquiries,
    path: '/enquiries',
    exact: true,
    strict: true,
  },
  {
    component: UserSaved,
    path: '/saved',
    exact: true,
    strict: true,
  },
  {
    path: '/reviews/:hash',
    component: Profile,
    exact: true,
    strict: true,
  },
  {
    path: '/profile/:businessName/:slug/:hash',
    component: Profile,
    exact: true,
    strict: true,
  },
  {
    path:
      '/profile/:businessName/:state(qld|nsw|nt|tas|vic|sa|wa|act)/:region/:suburb/:hash',
    component: Profile,
    exact: true,
    strict: true,
  },
  {
    path:
      '/profile/:businessName/:state(qld|nsw|nt|tas|vic|sa|wa|act)/:suburb/:hash',
    component: Profile,
    exact: true,
    strict: true,
  },
  {
    path: '/profile/:businessName/:businessName2/:slug/:hash',
    component: Profile,
    exact: true,
    strict: true,
  },
  {
    path:
      '/profile/:businessName/:state(qld|nsw|nt|tas|vic|sa|wa|act)/:region/:hash',
    component: Profile,
    exact: true,
    strict: true,
  },
  {
    path: '/:locationName/:businessName/profile/:hash',
    component: Profile,
    exact: true,
    strict: true,
  },
  {
    component: Suburb,
    path: '/:state(qld|nsw|nt|tas|vic|sa|wa|act)/:region/:suburb',
    exact: true,
    strict: true,
  },
  {
    component: Region,
    path: '/:state(qld|nsw|nt|tas|vic|sa|wa|act)/:region',
    exact: true,
    strict: true,
  },
  {
    component: State,
    path: '/:state(qld|nsw|nt|tas|vic|sa|wa|act)',
    exact: true,
    strict: true,
  },
  {
    path: '/manage-listing',
    component: ManageListing,
  },
  {
    path: '/login-loader',
    component: LoginLoader,
    exact: true,
    strict: true,
  },
  {
    path: '/listing-post/:id',
    component: ListingPost,
    exact: true,
    strict: true,
  },
  {
    component: NotFound,
  },
];

export default routes;
